import { APP_ROUTE } from '@backrs_ui/grow-ui/src/App';
import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import {
  OFFICE_HOURS_SESSION_TYPES,
  SOLUTION_SESSION_IDS,
} from '@backrs_ui/grow-ui/src/models/models';

import { ActionStickerCardSection, HomePageSection } from './useGetHomePageSections';

const GREAT_COLLEGE_STRINGS = appStrings.modules.home.sections.getBackedYourWay.greatCollege;
const SCORE_JOB_INTERNSHIP_STRINGS =
  appStrings.modules.home.sections.getBackedYourWay.scoreJobInternship;

export const GREAT_COLLEGE_SECTION = ({ navigate }: HomePageSection): ActionStickerCardSection => ({
  title: GREAT_COLLEGE_STRINGS.title,
  description: GREAT_COLLEGE_STRINGS.description,
  actionStickerCards: [
    {
      title: GREAT_COLLEGE_STRINGS.actionStickerCards.collegeShortlist.title,
      description: GREAT_COLLEGE_STRINGS.actionStickerCards.collegeShortlist.description,
      stickerUrl: '/images/stickers/Achievement.png',
      onClick: () =>
        navigate(
          APP_ROUTE.SOLUTION_SESSION.replace(':id?', SOLUTION_SESSION_IDS.COLLEGE_SHORTLIST),
        ),
    },
    {
      title: GREAT_COLLEGE_STRINGS.actionStickerCards.whatAreYourChances.title,
      description: GREAT_COLLEGE_STRINGS.actionStickerCards.whatAreYourChances.description,
      stickerUrl: '/images/stickers/Chances.png',
      onClick: () =>
        navigate(
          APP_ROUTE.OFFICE_HOURS.replace(':id?', OFFICE_HOURS_SESSION_TYPES.WHAT_ARE_YOUR_CHANCES),
        ),
    },
    {
      title: GREAT_COLLEGE_STRINGS.actionStickerCards.essayIdeas.title,
      description: GREAT_COLLEGE_STRINGS.actionStickerCards.essayIdeas.description,
      stickerUrl: '/images/stickers/BooksWriting.png',
      onClick: () =>
        navigate(APP_ROUTE.OFFICE_HOURS.replace(':id?', OFFICE_HOURS_SESSION_TYPES.ESSAY_IDEAS)),
    },
    {
      title: GREAT_COLLEGE_STRINGS.actionStickerCards.improveYourTestScores.title,
      description: GREAT_COLLEGE_STRINGS.actionStickerCards.improveYourTestScores.description,
      stickerUrl: '/images/stickers/DataChart.png',
      onClick: () =>
        navigate(
          APP_ROUTE.SOLUTION_SESSION.replace(':id?', SOLUTION_SESSION_IDS.IMPROVE_YOUR_TEST_SCORES),
        ),
    },
  ],
});

export const SCORE_JOB_INTERNSHIP_SECTION = ({
  navigate,
  getCompetencyUrl,
}: HomePageSection): ActionStickerCardSection => ({
  title: SCORE_JOB_INTERNSHIP_STRINGS.title,
  description: SCORE_JOB_INTERNSHIP_STRINGS.description,
  actionStickerCards: [
    {
      title: SCORE_JOB_INTERNSHIP_STRINGS.actionStickerCards.updateSocialMedia.title,
      description: SCORE_JOB_INTERNSHIP_STRINGS.actionStickerCards.updateSocialMedia.description,
      stickerUrl: '/images/stickers/DesignTech.png',
      onClick: () => navigate(getCompetencyUrl('Social media')),
    },
    {
      title: SCORE_JOB_INTERNSHIP_STRINGS.actionStickerCards.jobsYouMightLove.title,
      description: SCORE_JOB_INTERNSHIP_STRINGS.actionStickerCards.jobsYouMightLove.description,
      stickerUrl: '/images/stickers/Newspaper.png',
      onClick: () =>
        navigate(
          APP_ROUTE.SOLUTION_SESSION.replace(':id?', SOLUTION_SESSION_IDS.JOBS_YOU_MIGHT_LOVE),
        ),
    },
    {
      title: SCORE_JOB_INTERNSHIP_STRINGS.actionStickerCards.interviewing.title,
      description: SCORE_JOB_INTERNSHIP_STRINGS.actionStickerCards.interviewing.description,
      stickerUrl: '/images/stickers/Podcast.png',
      onClick: () => navigate(getCompetencyUrl('Interviewing')),
    },
    {
      title: SCORE_JOB_INTERNSHIP_STRINGS.actionStickerCards.boostOfferOdds.title,
      description: SCORE_JOB_INTERNSHIP_STRINGS.actionStickerCards.boostOfferOdds.description,
      stickerUrl: '/images/stickers/Games.png',
      onClick: () =>
        navigate(
          APP_ROUTE.OFFICE_HOURS.replace(':id?', OFFICE_HOURS_SESSION_TYPES.BOOST_ODDS_OF_AN_OFFER),
        ),
    },
  ],
});
